<template>
  <section class="relative overflow-hidden bg-[#061f47]">
    <div
      class="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-blue-500/20 blur-3xl"
    />

    <div
      class="absolute -bottom-32 left-1/3 h-72 w-72 rounded-full bg-orange-500/15 blur-3xl"
    />

    <div
      class="relative mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-[1.1fr_.9fr] lg:items-center lg:px-8"
    >
      <div>
        <span
          class="inline-flex rounded-full border border-blue-300/30 bg-blue-400/10 px-3 py-1.5 text-xs font-black uppercase tracking-[0.14em] text-blue-200"
        >
          Atendimento empresarial
        </span>

        <h2 class="mt-4 text-3xl font-black text-white md:text-4xl">
          Licenças para empresas e compras em quantidade
        </h2>

        <p class="mt-4 max-w-2xl leading-7 text-blue-100">
          Solicite orientação comercial para Windows Server, Windows Pro,
          Office, Microsoft 365 e outros produtos disponíveis no catálogo.
        </p>

        <div class="mt-7 grid gap-3 sm:grid-cols-2">
          <div
            v-for="item in benefits"
            :key="item"
            class="flex items-start gap-3 text-sm text-blue-50"
          >
            <span class="font-black text-blue-300">✓</span>
            <span>{{ item }}</span>
          </div>
        </div>

        <div class="mt-8 flex flex-wrap gap-3">
          <NuxtLink
            to="/categoria/windows-server"
            class="inline-flex min-h-12 items-center justify-center rounded-xl bg-blue-600 px-6 py-3 text-sm font-black text-white transition hover:bg-blue-500"
          >
            Ver Windows Server
          </NuxtLink>

          <a
            :href="whatsappUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex min-h-12 items-center justify-center rounded-xl border border-white/30 px-6 py-3 text-sm font-black text-white transition hover:bg-white/10"
          >
            Solicitar orçamento
          </a>
        </div>
      </div>

      <div
        class="rounded-3xl border border-white/10 bg-white/5 p-6 backdrop-blur md:p-8"
      >
        <p
          class="text-xs font-black uppercase tracking-[0.14em] text-orange-300"
        >
          Soluções profissionais
        </p>

        <h3 class="mt-3 text-2xl font-black text-white">
          Envie sua necessidade para nossa equipe
        </h3>

        <p class="mt-3 text-sm leading-6 text-blue-100">
          Informe os produtos, versões e quantidades para receber atendimento
          antes de concluir a compra.
        </p>

        <div class="mt-6 space-y-3">
          <NuxtLink
            v-for="item in products"
            :key="item.label"
            :to="item.to"
            class="flex items-center justify-between rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm font-bold text-white transition hover:bg-white/10"
          >
            <span>{{ item.label }}</span>
            <span class="text-blue-300">→</span>
          </NuxtLink>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const whatsappUrl =
  "https://wa.me/5511910512647?text=" +
  encodeURIComponent(
    "Olá! Preciso de um orçamento empresarial para múltiplas licenças.",
  );

const benefits = [
  "Atendimento para múltiplas licenças",
  "Orientação comercial antes da compra",
  "Documentação fiscal conforme a operação",
  "Suporte especializado de instalação",
];

const products = [
  {
    label: "Windows Server",
    to: "/categoria/windows-server",
  },
  {
    label: "Windows Pro",
    to: "/categoria/windows",
  },
  {
    label: "Office e Microsoft 365",
    to: "/categoria/office",
  },
];
</script>
